import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTreso = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_612_1820)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9886 0L0 8.17518V9.35604H28V8.17518L13.9886 0Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M26.8191 23.322H1.15815V25.661H0V28H28V25.661H26.8191V23.322Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.33887 19.8248V22.1638H9.33319V19.8248H7.58461V12.8305H9.33319V10.4915H2.33887V12.8305H4.08745V19.8248H2.33887Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M18.6665 19.8248V22.1638H25.6608V19.8248H23.9122V12.8305H25.6608V10.4915H18.6665V12.8305H20.4151V19.8248H18.6665Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.4917 19.8248V22.1638H17.486V19.8248H15.7374V12.8305H17.486V10.4915H10.4917V12.8305H12.2403V19.8248H10.4917Z",
				fill: "white"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_612_1820",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 28,
			height: 28,
			fill: "white"
		})
	}) })]
});
export default SvgTreso;
